import { useEffect, useState } from 'react'

const DEBOUNCE_DEFAULT_DELAY = 300

function useDebounce (value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || DEBOUNCE_DEFAULT_DELAY)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}

export default useDebounce
